import templateUrl from './search-box.html';

export const searchBoxComponent = {
    bindings: {
        type: '@',
        onSearch: '&',
        showStickyHeader: '@'
    },

    templateUrl,

    controller: class SearchBoXComponent {
        constructor($parse) {
			'ngInject';

			this.$parse = $parse;
		}

        $onInit() {
            this.searchKey = '';
            this._showStickyHeader = this.$parse(this.showStickyHeader || 'false')(false);
        }

        _onSearch() {
            if (this.searchKey) {
                this.onSearch({
                    $event: this.searchKey
                });
            }
            this.searchKey = '';
        }

        $onChanges(changes) {
			if(changes && changes.showStickyHeader) {
				this._showStickyHeader = this.$parse(changes.showStickyHeader.currentValue || 'true')(true);
			}
		}
    }
};


// WEBPACK FOOTER //
// ./src/app/common/components/search-box/search-box.component.js